import React from "react";
import { Carousel } from "react-bootstrap";

import MyCarousel from "components/MyCarousel";
import Profile from "./Websites";
import List from "./List";
import Emitter from "services/Emitter";

class Index extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            engine: null,
            bucket: null,
        };
        this.reloadProfile = this.reloadProfile.bind(this);
    }

    reloadProfile(engine, bucket) {
        if (engine === this.state.engine && bucket === this.state.bucket) {
            return;
        }
        this.setState({ engine, bucket });
        Emitter.emit("LOAD_BUCKET_PROFILE");
    }

    render() {
        const url = window.location.href;
        const match = url.match(/bucket\/(.*)\/(.*)/);
        const engine = match != null ? match[1] : null;
        const bucket = match != null ? match[2] : null;
        const key = engine !== null && bucket !== null ? 1 : 0;

        return (
            <MyCarousel
                activeIndex={key}
                onSlide={(tab) =>
                    tab === 1 && this.reloadProfile(engine, bucket)
                }
            >
                <Carousel.Item key="bucket.list" className="standardGrid">
                    <List />
                </Carousel.Item>
                <Carousel.Item key="bucket.profile" className="standardGrid">
                    <Profile engine={engine} bucket={bucket} />
                </Carousel.Item>
            </MyCarousel>
        );
    }
}
export default Index;
